import { select, put, takeLatest } from 'redux-saga/effects';

import * as getUser from './get-user';
import * as profileEditable from './profile-editable-req';
import * as getAccessLevel from './getAccessLevels';
import { currentLocationSelector } from '../common/selectors';
import { MESSAGES } from '../../constants/routes';
import { actions as loggedUserActions } from '../context/loggedUser';
import { actions as targetUserActions } from '../context/targetUser';
import { actions as mfaConfirmationActions } from './mfa-confirmations';
import * as enableMfa from './mfa-enable';
import * as disableMfa from './mfa-disable';

function* userSagaWorker({ payload }) {
  yield put(profileEditable.actions.send({ userId: payload.id }));
  const currentLocation = yield select(currentLocationSelector);

  if (currentLocation === `/${MESSAGES}`) {
    yield put(getAccessLevel.actions.send({ id: payload.id }));
  }
}

function* handleMfaCleanup({ payload }) {
  if (payload.mfaEnabled) {
    yield put(mfaConfirmationActions.clear());
  }
}

export function* userSaga() {
  yield takeLatest(getUser.consts.SUCCEED, userSagaWorker);
  yield takeLatest(getUser.consts.SUCCEED, handleMfaCleanup);
  yield takeLatest(
    [enableMfa.consts.SUCCEED, disableMfa.consts.SUCCEED],
    handleMfaChange,
  );
}

function* handleMfaChange({ payload }) {
  yield put(loggedUserActions.update(payload));
  yield put(targetUserActions.update(payload));
  yield put(mfaConfirmationActions.clear());
}



// WEBPACK FOOTER //
// ./src/redux/profiles/user-saga.js